import React, { useEffect, useRef } from 'react';

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isAndroid = () => /Android/.test(navigator.userAgent);

const YouTubePlayer = ({ videoId }) => {
  const containerRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!videoId) return;

    const muteSetting = isIOS() ? 1 : 0;

    const createPlayer = () => {
      if (!window.YT || !window.YT.Player || !containerRef.current) return;

      playerRef.current = new window.YT.Player(containerRef.current, {
        width: '100%',
        height: '100%',
        videoId,
        playerVars: {
          autoplay: 1,
          mute: muteSetting,
          rel: 0,
          modestbranding: 1,
          enablejsapi: 1,
          fs: 1,
          playsinline: 1,
        },
        events: {
          onReady: (event) => {
            const iframe = containerRef.current?.querySelector('iframe');
            if (iframe) {
              iframe.setAttribute('allowfullscreen', 'true');
              iframe.setAttribute('webkitallowfullscreen', 'true');
              iframe.setAttribute('mozallowfullscreen', 'true');
            }
            if (!isIOS()) {
              event.target.unMute();
            }
            event.target.playVideo();
          },
        },
      });
    };

    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
      window.onYouTubeIframeAPIReady = createPlayer;
    } else {
      createPlayer();
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, [videoId]);

  return <div ref={containerRef} style={{ width: '100%', height: '100%' }} />;
};

export default YouTubePlayer;